export const reorder = (list, oldIndex, newIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(oldIndex, 1);
  result.splice(newIndex, 0, removed);
  return result;
};
